/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Open_Email_ContinueInputs */

const en_mobile_open_email_continue = /** @type {(inputs: Mobile_Open_Email_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open it from your email to continue.`)
};

const es_mobile_open_email_continue = /** @type {(inputs: Mobile_Open_Email_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ábrelo desde tu correo para continuar.`)
};

/**
* | output |
* | --- |
* | "Open it from your email to continue." |
*
* @param {Mobile_Open_Email_ContinueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_open_email_continue = /** @type {((inputs?: Mobile_Open_Email_ContinueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Open_Email_ContinueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_open_email_continue(inputs)
	return en_mobile_open_email_continue(inputs)
});